import React from 'react';
import { Row, Col } from 'antd';
import { LoginLogo } from './overview/style';

const AuthLayout = WraperContent => {
  return () => {
    return (
      <>
        <Row>
          <Col xxl={24} xl={24} lg={24} md={24} xs={24}>                    
            <LoginLogo>
              <img src={require('../../../static/img/auth/logo-CDC.png')} height="120" className="logo" />
            </LoginLogo>            
          </Col>
        </Row>
        <Row>
          <Col xxl={24} xl={24} lg={24} md={24} xs={24}  className='text-center'>
            <br />
          <h3>C Dental Care Group</h3>          
            <WraperContent />
          </Col>
        </Row>
      </>
    );
  };
};

export default AuthLayout;
